<div class="ofertacard-global">
  <div class="contenidoofert-global">
    <div class="ico-global">
      <i class="mdi mdi-tag-heart-outline"></i>
    </div>
    <div class="descprod-global">
      {{ promocion.getNombrePromocion() }}
    </div>
    <div *ngIf="!ocultarPrecios" class="precie-global">
      {{ promocion.getPorcentaje() }}% de descuento
    </div>
    <div class="subtitulo-global">
      Se aplica solo en tu compra
    </div>
  </div>
</div>
